import React from 'react';

import CardStubWrapper from './CardStubWrapper';
import TopStub from './TopStub';
import MiddleStub from './MiddleStub';

class UserCardStub extends React.PureComponent {
  render() {
    return (
      <CardStubWrapper>
        <TopStub />

        <MiddleStub style={{ width: '72px' }} />

        <MiddleStub style={{ width: '152px' }} />

        <MiddleStub style={{ width: '120px' }} />
      </CardStubWrapper>
    );
  }
}

export default UserCardStub;
